<template>
    <v-card class="pa-3 ma-md-3">
        <loader v-if="isloading"></loader>
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <v-toolbar-title
                ><h3 style="overflow-wrap: normal">
                    Lista de
                    {{ $route.meta.rol == 1 ? "potenciales" : "clientes" }}
                </h3></v-toolbar-title
            >
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/${formpath}` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo cliente</span>
        </v-tooltip>
        <v-row align="end">
            <v-col align="end" cols="12">
                <v-btn
                    v-if="selected.length > 0"
                    @click="EliminarSeleccionados"
                    :disabled="isloading"
                    color="red"
                    class="white--text"
                    >Eliminar</v-btn
                >
            </v-col>
        </v-row>

        <!--Filtros-->
        <v-row>
            <v-col cols="12" md="8">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>

            <v-col cols="12" md="4">
                <v-btn
                    color="primary"
                    class="white--text mr-2"
                    @click="getClientes()"
                >
                    Filtrar
                </v-btn>
                <v-btn
                    color="red"
                    class="white--text mr-2"
                    @click="
                        filtros = {};
                        filtros_prueba = {};
                        getClientes();
                    "
                >
                    Limpiar filtros
                </v-btn>
                <v-btn color="success" @click="ExportExcel">
                    <v-icon class="white--text">mdi-file-excel</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <!--<v-col cols="12" md="4">
                <v-checkbox v-model="filtros.validacion" label="Pendientes Por Validación"></v-checkbox>
            </v-col>-->
        </v-row>
        <v-data-table
            dense
            v-model="selected"
            show-select
            :loading="loading"
            :headers="isMobile ? headers_mobile : headers"
            :items="Clientes"
            :search="search"
            @click:row="handleClick"
            :item-class="getRowClass"
            :items-per-page="100"
            item-key="id"
            :options.sync="options"
            class="elevation-1"
            :sort-by.sync="savedSortBy"
            :sort-desc.sync="savedSortDesc"
            @update:options="onOptionsUpdate"
            :footer-props="{
                'items-per-page-options': [100, 500],
            }"
            :server-items-length="total_cliente"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.conocido="{ item }">
                <span>{{ obtenerConocido(item) }}</span>
            </template>

            <template v-slot:item.fecha_alta="{ item }">
                <span>{{
                    (item.fecha_alta + "T" + item.created_at.split("T")[1])
                        | format_date_time_madrid
                }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <!--router-link--
                    :to="{ path: `/${formpath}?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </!--router-link-->
                <a
                    target="__blank"
                    :href="`tel:${item.telefono}`"
                    @click.stop="() => {}"
                    ><v-icon
                        style="pointer-events: none; font-size: 25px"
                        small
                        class="mr-2"
                        color="blue"
                        title="Llamar"
                        >mdi-phone</v-icon
                    ></a
                >
                <a
                    target="__blank"
                    :href="`https://wa.me/${item.telefono}`"
                    @click.stop="() => {}"
                    ><v-icon
                        style="pointer-events: none; font-size: 25px"
                        small
                        class="mr-2"
                        color="green"
                        title="Whatsapp"
                        >mdi-whatsapp</v-icon
                    ></a
                >
                <a @click.stop="">
                    <router-link
                        :to="`guardar-peticion?cliente=${item.id}&incidencia=0`"
                    >
                        <v-icon
                            style="pointer-events: none; font-size: 25px"
                            small
                            class="mr-2"
                            color="blue"
                            title="Aviso nuevo presupuesto"
                            >mdi-email</v-icon
                        >
                    </router-link>
                </a>
                <a @click.stop="openModal(item)">
                    <v-icon
                        style="pointer-events: none; font-size: 25px"
                        small
                        class="mr-2"
                        color="red"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <!--Dialog Eliminar cliente-->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Dialog Crear cliente-->
        <v-dialog v-model="dialog_comercial" max-width="1000px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear cliente
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="cliente.razon_social"
                                label="Razón social"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="cliente.nombre_comercial"
                                label="Nombre del comercial"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="cliente.cif"
                                label="CIF"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="checkCliente()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Dialog Mail-->
        <DialogMail
            v-model="dialog_mail"
            :id_cliente="cliente.id"
            :id_producto="cliente.interes"
        ></DialogMail>

        <!--Busqueda cliente-->
        <busqueda-cliente v-model="show_busqueda"></busqueda-cliente>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";
import BusquedaCliente from "./BusquedaCliente.vue";
import DialogMail from "./DialogMail.vue";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";

export default {
    data() {
        return {
            dialog_mail: false,
            agentes: [],
            filtros_prueba: {},
            filter_headers: [
                {
                    title: "Fecha",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
                {
                    title: "Agente",
                    type: "select",
                    active: false,
                    model: "agente",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "estado",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Originalmente potenciales",
                    type: "check",
                    active: false,
                    model: "rol_creacion",
                },
            ],
            agentes: [],
            options: {},
            sorted: true,
            show_busqueda: false,
            filtros: {
                validacion: 0,
            },
            all_selected: false,
            selected: [],
            search: "",
            page: 1,
            loading: false,
            busqueda: "buscar",
            cantidad: 100,
            total_cliente: -1,
            headers_agente: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    value: "nombre_comercial",
                    sortable: false,
                },
                { text: "Fecha de alta", value: "fecha_alta", sortable: false },
                { text: "CIF/NIF", value: "cif", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            headers: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    value: "nombre_comercial",
                    sortable: true,
                },
                { text: "Email", value: "email", sortable: true },
                { text: "Teléfono", value: "telefono", sortable: true },
                {
                    text: "Dirección",
                    // value: "dir.direccion",
                    value: "direccion",
                    sortable: true,
                },
                {
                    text: "Población",
                    //value: "dir.ciudad",
                    value: "ciudad",
                    sortable: true,
                },
                {
                    text: "Provincia",
                    // value: "dir.provincia_rel.nombre",
                    value: "provincia",
                    sortable: true,
                },
                {
                    text: "Comercial",
                    value: "agentes_str",
                    sortable: true,
                },
                {
                    text: "Creado por",
                    // value: "user.name",
                    value: "creado_por",
                    sortable: true,
                },
                {
                    text: "¿Cómo nos conocieron?",
                    // value: "cliente_conocidos.name",
                    value: "cliente_conocido",
                    sortable: true,
                },
                { text: "Fecha de alta", value: "fecha_alta", sortable: true },
                { text: "Acciones", value: "action", sortable: false },
            ],
            headers_mobile: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    value: "nombre_comercial",
                    sortable: false,
                },
                { text: "Acciones", value: "action", sortable: false },
            ],
            cliente: {
                cif: null,
                razon_social: "",
                nombre_comercial: "",
            },

            Clientes: [],
            selectedItem: 0,
            dialog_comercial: false,
            dialog: false,
            rol: 0,
            isMobile: false,

            agentes: [],
            conocido: [
                { id: 1, nombre: "Airclos" },
                { id: 2, nombre: "Empresa/Marca" },
                { id: 3, nombre: "Gimenez Ganga" },
                { id: 4, nombre: "Habitual (ya cliente)" },
                { id: 5, nombre: "Lumon España" },
            ],
            productos: [
                { id: 1, nombre: "Aluminio - Carpintería Metálica" },
                { id: 2, nombre: "Aluminio/PVC" },
                { id: 3, nombre: "Bioclimática" },
                { id: 4, nombre: "Cerrajería" },
                { id: 5, nombre: "CSP" },
            ],
            savedSortBy: [],
            savedSortDesc: [],
        };
    },
    mounted() {
        this.checkMobileView();
        // Listen for window resize events
        window.addEventListener("resize", this.checkMobileView);
    },
    beforeDestroy() {
        // Remove the resize event listener when the component is destroyed
        window.removeEventListener("resize", this.checkMobileView);
    },

    created() {
        if (this.$store.getters.getfiltros["potencial"] != null) {
            this.filtros_prueba = this.$store.getters.getfiltros["potencial"];
        }

        this.getEstadosPotencial();
        this.rol = localStorage.getItem("role");
        this.getAgentes();

        // this.getClientes();
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: function (val) {
                this.$store.dispatch("saveFiltrosPotencial", val);
            },
        },
        "$route.meta.rol": function (val) {
            this.getClientes();
        },
        "filtros.validacion": function (val) {
            this.getClientes();
        },
        search: debounce(function (val) {
            this.getClientes();
        }, 500),
        savedSortBy: function (val) {
            this.getClientes();
        },
        savedSortDesc: function (val) {
            this.getClientes();
        },
    },
    methods: {
        // Acciones de clientes
        // Listar clientes
        getClientes() {
            this.loading = true;
            /*let filtros = this.filterString;

            let filtro_agentes =
                this.filtros_prueba.id_agente != null
                    ? `&agente=${this.filtros.id_agente}`
                    : "";
            if (this.filtros.fecha_desde) {
                filtro_agentes += "&fecha_desde=" + this.filtros.fecha_desde;
            }
            if (this.filtros.fecha_hasta) {
                filtro_agentes += "&fecha_hasta=" + this.filtros.fecha_hasta;
            }
            if (this.filtros.rol_creacion) {
                filtro_agentes += "&rol_creacion=1";
            }*/

            axios
                // .get(
                //     `api/get-clientes/${this.cantidad}?page=${this.page}&rol=${this.$route.meta.rol}${filtros}`
                // )
                .get(`api/get-clientes/${this.cantidad}`, {
                    params: {
                        page: this.page,
                        rol: this.$route.meta.rol,
                        id_agente: this.filtros_prueba.agente?.value,
                        fecha_desde: this.filtros_prueba.fecha?.start,
                        fecha_hasta: this.filtros_prueba.fecha?.end,
                        rol_creacion: this.filtros_prueba.rol_creacion?.value,
                        busqueda: this.filtros_prueba.search,
                        sort_by: this.savedSortBy.join(","),
                        sort_desc: this.savedSortDesc.join(","),
                    },
                })
                .then(
                    (res) => {
                        this.Clientes = res.data.data;
                        this.total_cliente = res.data.total;
                        this.loading = false;
                        const sortBy = this.savedSortBy;
                        const sortDesc = this.savedSortDesc;

                        this.options = {
                            ...this.options,
                            sortBy: sortBy,
                            sortDesc: sortDesc,
                        };
                        //console.log(this.options);
                    },
                    (err) => {
                        this.$custom_error("Error consultando los clientes");
                        this.loading = false;
                    }
                );
        },

        // Acciones de sincronizacion de la tabla
        onOptionsUpdate(options) {
            if (options.sortBy.length > 0) {
                this.savedSortBy = options.sortBy;
                this.savedSortDesc = options.sortDesc;
                //console.log(this.savedSortDesc);
                this.getClientes();
                // Execute your custom fun
            }
        },
        handleClick(value) {
            this.$router.push(`/${this.formpath}?id=${value.id}`);
            //console.log(value);
        },
        ChangePage(event) {
            this.page = event.page;
            this.getClientes();
            //console.log(event);
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getClientes();
            //console.log(`evento: ${event}`);
        },

        // Eliminar cliente individual
        openModal(item) {
            this.selectedItem = this.Clientes.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-cliente", {
                    id: this.Clientes[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Cliente eliminado con éxito");
                        this.dialog = false;
                        this.getClientes();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el cliente");
                    }
                );
        },

        // Eliminar clientes seleccionados
        EliminarSeleccionados() {
            let ids = [];
            this.selected.forEach((elemento) => {
                ids.push(elemento.id);
            });
            axios.post(`api/delete-clientes`, { ids: ids }).then(
                (res) => {
                    this.getClientes();
                    this.selected = [];
                    this.$toast.sucs("Clientes eliminados con éxito");
                },
                (res) => {
                    this.$custom_error("Error eliminando los clientes");
                }
            );
        },

        // Exportar excel
        ExportExcel() {
            this.loading = true;
            // let filtros = this.filterString;

            axios
                // .get(
                //     `/api/excel-cliente?rol=${this.$route.meta.rol}${filtros}`,
                //     { responseType: "blob" }
                // )
                .get(`/api/excel-cliente`, {
                    params: {
                        rol: this.$route.meta.rol,
                        id_agente: this.filtros_prueba.agente?.value,
                        fecha_desde: this.filtros_prueba.fecha?.start,
                        fecha_hasta: this.filtros_prueba.fecha?.end,
                        rol_creacion: this.filtros_prueba.rol_creacion?.value,
                        busqueda: this.filtros_prueba.search,
                    },
                    responseType: "blob",
                })
                .then((response) => {
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "clientes.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.loading = false;
                })
                .catch((error) => {
                    console.error("Error exporting clientes:", error);
                });
        },

        // Metodos generales
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.filter_headers[1].items = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                    this.agentes = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                },
                (res) => {}
            );
        },
        getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then(
                (res) => {
                    this.filter_headers[2].items = res.data;
                },
                (res) => {}
            );
        },

        // Abrir modal comercial
        openModalComercial(item) {
            this.dialog_comercial = true;
        },
        checkCliente() {
            axios.post(`api/check-cliente-comercial`, this.cliente).then(
                (res) => {
                    //console.log(res.data);
                    if (res.data.status) {
                        this.$router.push(
                            `${this.formpath}?rs=${this.cliente.razon_social}&cif=${this.cliente.cif}&nombre=${this.cliente.nombre_comercial}`
                        );
                    } else {
                        this.$custom_error(res.data.msg);
                    }
                },
                (res) => {
                    this.$custom_error("Error consultando el cliente");
                }
            );
        },

        // Metodos auxiliares
        checkMobileView() {
            this.isMobile = window.innerWidth <= 768; // Set the breakpoint value as per your needs
        },
        getRowClass(item) {
            if (item.agentes.length > 0)
                if (item.agentes[0].agente_relation != null)
                    if (item.agentes[0].agente_relation.estadistica == 0) {
                        return "yellow";
                    }

            return "pointer";
        },
        showBusqueda() {
            this.show_busqueda = true;
        },
        obtenerConocido(item) {
            let nombre = "";
            this.conocido.forEach((element) => {
                if (element.id == item.id) {
                    nombre = element.nombre;
                }
            });
            return nombre;
        },

        // En desuso
        openMailModal(item) {
            this.dialog_mail = true;
            console.log(item);
            this.cliente = item;
        },
        obtenerInteres(item) {
            let nombre = "";
            this.productos.forEach((element) => {
                if (element.id == item.id) {
                    nombre = element.nombre;
                }
            });
            return nombre;
        },
        downloadFile(response) {
            let blob = new Blob([response.data], { type: "xlsx" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        },
        exportAll() {
            axios
                .get("/api/export-clientes", {
                    responseType: "blob",
                })
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        exportSelected() {
            let ids = [];
            this.selected.forEach((elemento) => {
                ids.push(elemento.id);
            });
            axios
                .post(
                    "/api/export-clientes",
                    { ids: ids },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        exportFiltered() {
            let ids = [];

            axios
                .post(
                    "/api/export-clientes-filtered",
                    { agente: this.filtros.id_agente },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
    },
    filters: {},
    components: {
        BusquedaCliente,
        FilterComponentVue,
        DialogMail,
    },
    computed: {
        filterString() {
            let filtros = "";
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&busqueda=${this.filtros_prueba.search}`;
            }
            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (head.type == "date") {
                        if (
                            this.filtros_prueba[head.model].start != "" &&
                            this.filtros_prueba[head.model].start != null
                        ) {
                            filtros += `&${head.model}_desde=${
                                this.filtros_prueba[head.model].start
                            }`;
                        }
                        if (
                            this.filtros_prueba[head.model].end != "" &&
                            this.filtros_prueba[head.model].end != null
                        ) {
                            filtros += `&${head.model}_hasta=${
                                this.filtros_prueba[head.model].end
                            }`;
                        }
                    } else {
                        if (
                            (this.filtros_prueba[head.model].value != "" &&
                                this.filtros_prueba[head.model].value !=
                                    null) ||
                            (this.filtros_prueba[head.model].nombre != "" &&
                                this.filtros_prueba[head.model].nombre != null)
                        ) {
                            filtros += `&${head.model}=${
                                this.filtros_prueba[head.model].value
                            }`;
                        }
                    }
                }
            });
            return filtros;
        },
        formpath: function () {
            return `guardar-${
                this.$route.meta.rol == 1 ? "potencial" : "cliente"
            }`;
        },
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
